import { useMemo } from 'react';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable.tsx';
import { useMantineTableDataOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperations.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useSecurityTypeTranslation } from '@dealstack/frontend/shared/translationControllers/useCommonTranslationsController.ts';
import { InvestmentAllocationsProps } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsContent/components/InvestmentAllocations/InvestmentAllocations.types.ts';
import { getInvestmentAllocationsTableColumns } from './investmentAllocationsTable.utils.tsx';

type Props = InvestmentAllocationsProps;

export const InvestmentAllocationsTable = ({
	allocations,
	canMutateAllocations,
	onEditAllocation,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const getSecurityTypeTranslation = useSecurityTypeTranslation();
	const dataOperations = useMantineTableDataOperations();

	const columns = useMemo(() => {
		return getInvestmentAllocationsTableColumns({
			tMipManage,
			getSecurityTypeTranslation,
			canMutateAllocations,
			onEditAllocation,
		});
	}, [tMipManage, getSecurityTypeTranslation, canMutateAllocations, onEditAllocation]);

	if (!allocations?.length) {
		return null;
	}

	return (
		<MantineTable
			columns={columns}
			data={allocations}
			dataOperations={dataOperations}
			manualFiltering={false}
			manualSorting={false}
			enableTopToolbar={false}
			enablePagination={false}
			hideBorders={true}
			pinnedColumnIds={['securityName']}
		/>
	);
};
